/** Heart loader - yellow painted heart */
export function Loader({ className = "" }: { className?: string }) {
  return (
    <div className={`loader-heart ${className}`}>
      <svg viewBox="0 0 48 48" className="w-14 h-14">
        {/* Glow layer */}
        <path
          d="M24 42c-1.5-1.5-4-3.5-7-6.5C11 30 4 23 4 15c0-6 5-11 11-11 3.5 0 6.5 1.5 9 4.5 2.5-3 5.5-4.5 9-4.5 6 0 11 5 11 11 0 8-7 15-13 20.5-3 3-5.5 5-7 6.5z"
          fill="#fcd34d"
          opacity="0.3"
          style={{ filter: "blur(4px)" }}
        />

        {/* Main heart */}
        <path
          d="M24 40c-1.2-1.2-3.5-3-6.5-5.8C11.5 29 5 22.5 5 15.5 5 10 9.5 5.5 15 5.5c3 0 5.8 1.3 8 3.8l1 1.2 1-1.2c2.2-2.5 5-3.8 8-3.8 5.5 0 10 4.5 10 10 0 7-6.5 13.5-12.5 18.7-3 2.8-5.3 4.6-6.5 5.8z"
          fill="#fbbf24"
        />

        {/* Light highlight */}
        <path
          d="M14 14c1.5-2 4-3 6-2"
          stroke="#fef3c7"
          strokeWidth="2"
          strokeLinecap="round"
          fill="none"
          opacity="0.6"
        />
      </svg>
    </div>
  );
}
